// dependencies
import { useEffect, useRef, useState } from "react";

// libraries
import { noop } from "@cloudspire/legacy-shared/src/libraries";

interface MyWindow extends Window {
  grecaptcha;
}

declare const window: MyWindow;

const getOrGenerateScript = ({ siteKey }) => {
  let $script: HTMLScriptElement = document.querySelector(
    `[data-recaptcha-key="${siteKey}"]`
  );
  if (null !== $script) {
    return $script;
  } else {
    $script = document.createElement("script");
    $script.src = `https://www.google.com/recaptcha/api.js?render=${siteKey}`;
    $script.dataset.recaptchaKey = siteKey;
  }

  document.body.appendChild($script);

  return $script;
};

const useRecaptcha = ({ siteKey, action }) => {
  const generateRecaptchaToken = useRef<() => Promise<string>>(noop);

  const [, setReady] = useState(false);

  const setGrecaptchaReady = () => {
    generateRecaptchaToken.current = () =>
      new Promise((resolve, reject) =>
        window.grecaptcha.execute(siteKey, { action }).then(resolve, reject)
      );

    setReady(true);
  };

  useEffect(() => {
    if (window.grecaptcha) {
      window.grecaptcha.ready(setGrecaptchaReady);
    } else {
      const $script = getOrGenerateScript({ siteKey });

      $script.addEventListener("load", () => {
        window.grecaptcha.ready(setGrecaptchaReady);
      });
    }
  });

  return generateRecaptchaToken.current;
};

export default useRecaptcha;
